import { createSlice, createSelector } from '@reduxjs/toolkit';
import { inGame, getEnded, getCurrentPlayer, getLocalPlayerNo } from '../game/gameSlice';
import { getLocalPlayer } from '../room/roomSlice';
import titleEnum from './titleEnum';
import { getCurrentRoom } from '../rooms/roomsSlice';

export const viewSlice = createSlice({
  name: 'view',
  initialState: {
    selected: 'main',
    dialogs: [],
  },
  reducers: {
    setSelected: (state, action) => {
      const payload = action.payload;
      state.selected = payload.tab;
    },
    addDialog: (state, action) => {
      const payload = action.payload;
      state.dialogs.push(payload);
    },
    closeDialog: (state, action) => {
      const type = action.payload;
      state.dialogs = state.dialogs.filter(d => d.type !== type);
    },
  },
});

export const { setLoading } = viewSlice.actions;

export const getSelected = (state) => {
  return state.view.selected;
};

export const getGameTabEnabled = (state) => {
  if (inGame(state)) {
    return true;
  }

  const player = getLocalPlayer(state);
  return player !== null && player.table !== null;
};

export const getCanJoinGame = (state) => {
  const player = getLocalPlayer(state);
  if (player === null || player.table === null) {
    return true;
  }

  return inGame(state) && (getEnded(state) || getLocalPlayerNo(state) === null);
}

export const getSubTitleAndPath = createSelector(
  [
    getSelected,
    inGame,
    getEnded,
    getCurrentPlayer,
    getLocalPlayerNo,
    getLocalPlayer,
    getCurrentRoom,
  ],
  (selected, inGame_, ended, currentPlayer, localPlayerNo, localPlayer, room) => {
    return (() => {
      switch (selected) {
        case 'main':
          return [{ type: titleEnum.HOME }, 'home', {tab: 'main'}, '?'];
        case 'room':
          return [{ type: titleEnum.LOBBY, args: { name: room.name} }, 'lobby', {tab: 'room', id: room.id}, '?roomid='+room.id];
        default: {
          const state = {tab: 'room', id: room.id };
          const url = '?roomid='+room.id;
          if (inGame_) {
            const path = 'game';
            if (ended) {
              return [{ type: titleEnum.GAME_OVER }, path, state, url];
            }
            if (currentPlayer === null) {
              return [ { type: titleEnum.GAME_WAIT_TO_START }, path, state, url];
            }
            if (currentPlayer.no === localPlayerNo) {
              return [ { type: titleEnum.GAME_YOUR_TURN }, path, state, url];
            } else {
              return [ { type: titleEnum.GAME_WAIT_TURN, args: { player: currentPlayer.name } }, path, state, url];
            }
          }
          if (localPlayer !== null && localPlayer.table !== null) {
            return [ { type: titleEnum.GAME_LOBBY }, 'game-lobby', state, url];
          }
          return [{ type: titleEnum.GAME_CREATE }, 'game-create', state, url];
        }
      }
    })();
  }
);

export const getCurrentDialog = (state) => {
  return state.view.dialogs[state.view.dialogs.length - 1] ?? null;
}

export default viewSlice.reducer;
